export default "__VITE_ASSET__ZNzLA2Wq__";